export default __webpack_public_path__ + "static/media/mode-532.0853ef1c.svg";